import { useContext } from "react";
import { Navigate, Outlet } from "react-router";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import { PortalLoginContext } from "@lending/pages/PortalLogin/PortalLoginContext";

const LOAN_PORTAL_FLOW = "loan_portal";

/**
 * Keeps the later login steps unreachable without an in-flight challenge.
 *
 * The challenge only lives in memory, so a deep link or a refresh on
 * `select-email` / `verify` arrives with nothing to submit. Sending those back to
 * the start beats rendering a step whose every submission would fail.
 */
export function PortalLoginGuard({ requireChallenge = true }: { requireChallenge?: boolean }) {
  const { institution } = useGetInstitutionQuery();
  const portalLogin = useContext(PortalLoginContext);

  if (!institution.lending_flows_enabled.includes(LOAN_PORTAL_FLOW)) {
    return <Navigate to="/" replace />;
  }

  if (requireChallenge && !portalLogin?.challenge) {
    return <Navigate to="/portal/login" replace />;
  }

  return <Outlet />;
}
